import { PreflightStatus } from "shared-utils/enums/creativex";

import type { GQLPaginatedDeliverable } from "@/apollo/types";
import type { ConstructedDeliverable } from "@/types/types";

export default function createPreflightStatusForDeliverables(
    deliverable: GQLPaginatedDeliverable,
    hasCreativeXEnabled: boolean
): ConstructedDeliverable["preflight"] {
    if (hasCreativeXEnabled) {
        return getCreativeXStatus(deliverable);
    }

    return {
        status: PreflightStatus.NOT_SENT
    };
}

function getCreativeXStatus(deliverable: GQLPaginatedDeliverable):
    | {
          status: "NOT_SENT" | "MODIFIED" | "PROCESSING" | "ERROR";
      }
    | {
          score: number;
          status: "COMPLETED";
      } {
    /**
     * we normalize the status here since not having a status means it was never sent for preflight testing
     * but having the status NOT_SENT means it has been sent for preflight testing in the past but the deliverable has since been modified
     */
    if (!deliverable.publishedStatus) {
        return {
            status: PreflightStatus.NOT_SENT
        };
    }

    if (!("creativex" in deliverable.publishedStatus)) {
        return {
            status: PreflightStatus.NOT_SENT
        };
    }

    if (
        !("status" in deliverable.publishedStatus.creativex) ||
        deliverable.publishedStatus.creativex.status === undefined
    ) {
        return {
            status: PreflightStatus.ERROR
        };
    }

    if (
        deliverable.publishedStatus.creativex.status === PreflightStatus.ERROR ||
        deliverable.publishedStatus.creativex.status === PreflightStatus.PROCESSING
    ) {
        return {
            status: deliverable.publishedStatus.creativex.status
        };
    }

    if (deliverable.publishedStatus.creativex.status === PreflightStatus.NOT_SENT) {
        return {
            status: PreflightStatus.MODIFIED
        };
    }

    if ("score" in deliverable.publishedStatus.creativex && deliverable.publishedStatus.creativex.score !== undefined) {
        return {
            score: deliverable.publishedStatus.creativex.score,
            status: deliverable.publishedStatus.creativex.status
        };
    }

    return {
        status: PreflightStatus.ERROR
    };
}
